import { FC } from 'react'

import { IconTelegram } from 'components/icons/telegram'
import { IconFacebook } from 'components/icons/facebook'
import { IconVk } from 'components/icons/vk'
import { IconYoutube } from 'components/icons/youtube'
import { IconInstagram } from 'components/icons/instagram'
import { Container } from 'components/container'
import { IconTwitter } from 'components/icons/twitter'
import {
  About,
  Authors,
  Copyright,
  Heading,
  Social,
  SocialLinks,
  StyledFooter,
} from './styled'

type Props = {}

const socialConfig = {
  facebook: {
    icon: <IconFacebook />,
    link: 'https://www.facebook.com/azatliq',
  },
  vkontakte: {
    icon: <IconVk />,
    link: 'https://vk.com/azatliq_radiosi',
  },
  twitter: { icon: <IconTwitter />, link: 'https://x.com/azatliq' },
  instagram: {
    icon: <IconInstagram />,
    link: 'https://www.instagram.com/azatliq/',
  },
  telegram: {
    icon: <IconTelegram />,
    link: 'https://telegram.me/joinchat/CxW5dz9ILszGJNLz9gk_RQ',
  },
  youtube: {
    icon: <IconYoutube />,
    link: 'https://www.youtube.com/user/azatliqradiosi',
  },
}

const parseSocial = () => (
  <SocialLinks>
    {Object.keys(socialConfig).map(k => {
      const networkConfig = socialConfig[k as keyof typeof socialConfig]

      return networkConfig ? (
        <li key={k}>
          <a href={networkConfig.link} target="_blank" rel="noreferrer">
            {networkConfig.icon}
          </a>
        </li>
      ) : null
    })}
  </SocialLinks>
)

export const Footer: FC<Props> = () => (
  <Container>
    <StyledFooter>
      <Authors>
        <Heading>Проектны башкаручылар</Heading>
        <p>
          <strong>Авторлар:</strong> Азатлык радиосы
          <br />
          <strong>Дизайн:</strong> Pangea Digital Dataviz team
          <br />
        </p>
      </Authors>
      <Social>
        <Heading>Кушылыгыз</Heading>
        {parseSocial()}
      </Social>
      <About>
        <Heading>Азатлык турында</Heading>
        <p>
          Азатлык радиосы – Азат Европа/Азатлык радиосының (Radio Free
          Europe/Radio Liberty) татар һәм башкорт телләрендәге хезмәте. Без
          Татарстан, Башкортстан һәм дөньяның башка төбәкләрендәге вакыйгаларны
          объектив яктыртырга, андагы кешеләргә үз фикерен әйтергә мөмкинлек
          бирергә, алар җирле һәм федераль медиа чараларыннан ала алмаган
          мәгълүмат җиткерергә тырышабыз. Проблемнарны ачык тикшерү генә аларны
          хәл итүгә ярдәм итә ала дип саныйбыз.
        </p>
      </About>
      <Copyright>
        Азатлык Радиосы © {new Date().getFullYear()} RFE/RL, Inc. | Бар хокуклар
        сакланган
      </Copyright>
    </StyledFooter>
  </Container>
)
